import { createContext } from 'react';

//Dark Mode Context created and exported to App.js & themeToggler
export const DarkModeContext = createContext({ toggleDarkMode: () => {} });

